// extracted by mini-css-extract-plugin
module.exports = {"container":"Quize_container__2R1UP","right":"Quize_right__mRCbL","wrong":"Quize_wrong__31TKP","tooltip":"Quize_tooltip__3A66b","bg":"Quize_bg__q4BVa","value":"Quize_value__28dax"};